import React from 'react';

const rowSpcBtween = (): React.CSSProperties => {
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  };
};

export default rowSpcBtween;
